import { Button, IconButton } from "materia"
import { useTranslation } from "react-i18next"
import s from "./NotificationPermissionBanner.module.scss"

type NotificationBannerViewProps = {
  onEnable: () => void
  onDismiss: () => void
}

/** Presentational, so Storybook can show it; the container drives it. */
export function NotificationBannerView({
  onEnable,
  onDismiss,
}: NotificationBannerViewProps) {
  const { t } = useTranslation()

  return (
    <div className={s.banner}>
      <span className={s.banner__text}>{t("chat.NOTIFICATION_BANNER")}</span>
      <Button size="medium" onClick={onEnable}>
        {t("chat.NOTIFICATION_BANNER_ENABLE")}
      </Button>
      <IconButton
        as="button"
        icon="Close"
        size="small"
        aria-label={String(t("chat.NOTIFICATION_BANNER_DISMISS_ARIA"))}
        onClick={onDismiss}
      />
    </div>
  )
}
